import script from "./kxOnceImg3.vue?vue&type=script&setup=true&lang=js"
export * from "./kxOnceImg3.vue?vue&type=script&setup=true&lang=js"

import "./kxOnceImg3.vue?vue&type=style&index=0&id=a48c02ac&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a48c02ac"]])

export default __exports__